import { config } from "../utils/config";

export const userRoleAPIPath = `${config.baseUrl}/user-role`;
export const userDetailAPIPath = `${config.baseUrl}/userdetail`;
export const mentorStatusAPIPath = `${config.baseUrl}/mentorStatus`;
export const mentorStatusAdminAPIPath = `${config.baseUrl}/mentorStatusAdmin`;
